export const buildMetaRobotsContent = (value?: string): string => {
  let defaultContent = 'max-snippet:-1, max-video-preview:-1, max-image-preview:large';
  if (value) defaultContent = `${value}, ${defaultContent}`;
  return defaultContent;
};
